import React from 'react';
import MainContent from 'shared/components/common/MainContent';
import useTitleUpdate from 'shared/utils/hooks/useTitleUpdate';

const EmploymentInfo: React.FC<{}> = () => {
    useTitleUpdate('Employment Info');
    return (
        <MainContent>
            <h1>Employment Info component works!</h1>
        </MainContent>
    );
};

export default EmploymentInfo;
